import { endpoints } from 'src/utils/axios';
import axiosPublic from './base';

// ----------------------------------------------------------------------

export async function registerBorrowBook(formData: any) {
  const URL = endpoints.public.loan_book_register;

  const { data } = await axiosPublic.post(URL, formData);

  return data;
}

export async function registerBorrowBookConfirm(formPayload: any) {
  const URL = endpoints.public.comfirm_loan_book_register;

  const { data } = await axiosPublic.post(URL, formPayload);

  return data;
}
